import React from 'react';

const Input = ({
  label,
  placeholder,
  name,
  type,
  className,
  value, // Use value for controlled input
  onChange,
  Icon,
  defaultValue,
  required
}) => {
  return (
    <div className="relative">
      <label htmlFor={name} className="block mb-2 text-sm font-medium text-gray-900">
        {label}
      </label>
      <input
        style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
        required={required}
        onChange={onChange}
        value={value} // Bind value to the input field
        placeholder={placeholder}
        name={name}
        id={name}
        type={type}
        defaultValue={defaultValue}
        className={`outline-none py-3.5 text-black placeholder:text-primary rounded-md ${className}`}
      />
      <div className="absolute right-3 top-2.5">
        <i>{Icon}</i>
      </div>
    </div>
  );
};

export default Input;
